var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tree[0]
    ? _c("div", { staticClass: "panel panel-gray wraper" }, [
        _vm.tree.length > 10
          ? _c(
              "div",
              { staticClass: "panel-header" },
              [
                _c("q-input", {
                  staticStyle: { width: "400px" },
                  attrs: {
                    name: "filter",
                    "float-label": "&#128269; в названии",
                    clearable: ""
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "panel-group",
            class: { scroll: _vm.$route.meta.showLeft }
          },
          [
            _c("q-tree", {
              attrs: {
                nodes: _vm.tree,
                "node-key": "key",
                selected: _vm.selected,
                filter: _vm.filter,
                "text-color": "primary"
              },
              on: {
                "update:selected": function($event) {
                  _vm.selected = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "header-variant",
                  fn: function(prop) {
                    return _c(
                      "div",
                      {},
                      [
                        _c("q-icon", {
                          staticClass: "q-tree-icon",
                          attrs: { name: "fas fa-file-alt" }
                        }),
                        _vm._v(" "),
                        _c("q-icon", {
                          staticClass: "q-tree-icon q-mr-sm",
                          attrs: { name: "far fa-file-alt", color: "warning" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(prop.node.label))])
                      ],
                      1
                    )
                  }
                },
                {
                  key: "header-draft",
                  fn: function(prop) {
                    return _c(
                      "div",
                      {},
                      [
                        _c("q-icon", {
                          staticClass: "q-tree-icon q-mr-sm",
                          attrs: { name: "far fa-file-alt", color: "warning" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-warning" }, [
                          _vm._v(_vm._s(prop.node.label))
                        ])
                      ],
                      1
                    )
                  }
                },
                {
                  key: "header-disabled",
                  fn: function(prop) {
                    return _c(
                      "div",
                      { staticClass: "cursor-not-allowed" },
                      [
                        _c("q-icon", {
                          staticClass: "q-tree-icon q-mr-sm",
                          attrs: { name: "fas fa-file-alt", color: "light" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-light" }, [
                          _vm._v(_vm._s(prop.node.label))
                        ])
                      ],
                      1
                    )
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "q-btn",
              {
                directives: [
                  {
                    name: "back-to-top",
                    rawName: "v-back-to-top.animate",
                    value: 500,
                    expression: "500",
                    modifiers: { animate: true }
                  }
                ],
                staticClass: "fixed-bottom-left",
                staticStyle: { margin: "0 0 15px 15px" },
                attrs: { round: "", color: "teal-5" }
              },
              [_c("q-icon", { attrs: { name: "keyboard_arrow_up" } })],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05274982", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05274982","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree-wiki.vue
// module id = null
// module chunks = 